// extracted by mini-css-extract-plugin
export default {"relative":"bhzfe","arrows":"Opzub","arrow":"TBn4N","arrow--left":"GWLbP","arrow--right":"Zc1iT","dots--left":"uJhEA","skeleton-progress":"_1YrlB"};